module.exports = __webpack_public_path__ + "img/BonSens.da56ad10.png";